<template>
  <div>代理余额总表</div>
</template>

<script>
export default {

}
</script>

<style>

</style>